var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("formulate-adapter", {
    ref: "adapter",
    attrs: {
      "view-only": _vm.viewOnly,
      debug: _vm.debug,
      "form-definition": _vm.formDefinition,
    },
    model: {
      value: _vm.formdata,
      callback: function ($$v) {
        _vm.formdata = $$v
      },
      expression: "formdata",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }